import addressApi from "api/AddressApi";
import {
  FETCH_LIST_CITY_SUCCESS,
  FETCH_LIST_DISTRICT_SUCCESS,
  FETCH_LIST_WARD_SUCCESS,
} from "redux/ActionTypes/AddressTypes";

export const fetchListCityRequest = () => {
  return (dispatch) => {
    addressApi.getAllCity().then(
      (res) => {
        dispatch(
          fetchListCitySuccess(
            res.data.results.map((item) => {
              return {
                name: item.province_name,
                value: item.province_id,
              };
            })
          )
        );
      },
      (err) => console.log(err)
    );
  };
};

export const fetchListDistrictRequest = (idCity) => {
  return (dispatch) => {
    addressApi.getDistrictsByIdCity(idCity).then(
      (res) => {
        dispatch(
          fetchListDistrictSuccess(
            res.data.results.map((item) => {
              return {
                name: item.district_name,
                value: item.district_id,
              };
            })
          )
        );
      },
      (err) => console.log(err)
    );
  };
};

export const fetchListWardRequest = (idDistrict) => {
  return (dispatch) => {
    addressApi.getWardsByIdDistrict(idDistrict).then(
      (res) => {
        dispatch(
          fetchListWardSuccess(
            res.data.results.map((item) => {
              return {
                name: item.ward_name,
                value: item.ward_id,
              };
            })
          )
        );
      },
      (err) => console.log(err)
    );
  };
};

export const fetchListCitySuccess = (data) => {
  return {
    type: FETCH_LIST_CITY_SUCCESS,
    payload: data,
  };
};

export const fetchListDistrictSuccess = (data) => {
  return {
    type: FETCH_LIST_DISTRICT_SUCCESS,
    payload: data,
  };
};

export const fetchListWardSuccess = (data) => {
  return {
    type: FETCH_LIST_WARD_SUCCESS,
    payload: data,
  };
};
